import { getInstalacionSofnet } from "../actions/erp";
import { toast } from "react-toastify";

export default function useEstadoInstalacionSofnet() {


  async function handleValidacion(id_instalacion_externa?: string | null): Promise<boolean> {

    if (!id_instalacion_externa) return false;

    try {
      const resp = await getInstalacionSofnet(id_instalacion_externa);

      if (resp?.code != 200) return false

      if (resp.data.estado_instalacion == "OK") {
        toast.info('No es posible acceder a la venta, debido a que el proceso con el técnico se encuentra finalizado.')
        return true
      }

    } catch (error) {
      toast.error('Error al consultar el servicio externo [500]')
    }

    return false

  }

  return {
    handleValidacion
  }

}